import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useBrandName } from "core/hooks/useBrandName";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { getYear } from "date-fns/getYear";
import { NotificationDot } from "features/Notifications/NotificationDot";
import { useTranslation } from "react-i18next";
import { CustomLink } from "../CustomLink";
import { JoinChildren } from "../JoinChildren";
import { useMobileMenuItems } from "../MobileNav/useMobileMenuItems";

export function FooterLegal() {
  const brandName = useBrandName();
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:FooterLegal",
  });
  const { isMobile } = useBreakpoints();
  const { menuItems } = useMobileMenuItems("Legal");
  const linkProps = {
    variant: "caption",
    textAlign: "center",
    color: "primary.contrastText",
  } as const;
  return (
    <Stack py={1} gap={1} color="primary.contrastText" bgcolor="primary.main">
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <JoinChildren JoinElement={<Typography {...linkProps}>|</Typography>}>
          {Array.isArray(menuItems) &&
            menuItems.map(({ displayName, id, url, target }) =>
              url ? (
                <CustomLink
                  key={id}
                  {...linkProps}
                  href={url}
                  target={target ?? undefined}
                >
                  {displayName} <NotificationDot id={id} mode="self" />
                </CustomLink>
              ) : (
                <Typography key={id} {...linkProps}>
                  {displayName}
                </Typography>
              )
            )}
          {!isMobile ? (
            <Typography {...linkProps}>
              {t("copyright", {
                year: getYear(new Date()),
                brandName,
              })}
            </Typography>
          ) : null}
        </JoinChildren>
      </Stack>
      {isMobile && (
        <Typography {...linkProps}>
          {t("copyright", {
            year: getYear(new Date()),
            brandName,
          })}
        </Typography>
      )}
    </Stack>
  );
}
